export default "__VITE_ASSET__CaEPD28K__"